<template>
    <div class="contactList">
        <div v-if="isEmpty" class="open-people-list">
            <a href="javascript:void(0)" v-on:click="openPeopleTab">{{$t("str.SelectContactInTheSession")}}</a>
        </div>
        <ul v-else class="contacts">
            <chatlistitem v-for="(contact, index) in otherContacts" :key="index" :user="user" :contact="contact" :isSelected="person && contact.to[0] === person.id"></chatlistitem>
        </ul>
    </div>
</template>

<script>

import ChatListItem from '@/components/chat/ChatListItem';
import {EventBus} from '../../router/index';

export default {
    components: {
        chatlistitem: ChatListItem
    },

    props: {
        contacts: {},
        user: {},
        person: {}
    },

    computed: {
        isEmpty() {
            return this.otherContacts.length === 0;
        },

        otherContacts() {
            return this.contacts ? this.contacts.filter(contact => contact.to[0] !== this.user.id) : [];
        }
    },

    watch: {
        contacts() {
            this.selectedDefaultPerson();
        }
    },

    methods: {
        openPeopleTab() {
            EventBus.$emit('openPeople');
        },

        selectedDefaultPerson() {
            if (this.otherContacts.length > 0) {
                EventBus.$emit('openChat', this.otherContacts[0].toInfo);
            }
        }
    }
};

</script>

<style lang="scss">

.contactList {
    .contacts {
        list-style-type: none;
        padding: 0;
        margin: 0px;
    }

    .open-people-list {
        width: 100%;
        height: 100%;
        display: table;

        & > a {
            color: white;
            padding: 0 30px;
            width: 100%;
            text-align: center;
            font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;
            display: table-cell;
            vertical-align: middle;

            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }
    }
}

</style>



// WEBPACK FOOTER //
// ChatContacts.vue?22f8b3bb